import PropTypes from 'prop-types';

export const advisorInfoProps = PropTypes.shape({
	advisorName: PropTypes.string.isRequired,
	advisorEmail: PropTypes.string.isRequired,
	advisorCompany: PropTypes.string.isRequired
});

export const clientInfoProps = PropTypes.shape({
	assetsAmount: PropTypes.string.isRequired,
	annualIncome: PropTypes.string.isRequired,
	clientId: PropTypes.string,
	clientFullName: PropTypes.string.isRequired,
	creditScoreValue: PropTypes.string,
	dateOfBirth: PropTypes.string.isRequired,
	emailAddressValue: PropTypes.string.isRequired,
	firstName: PropTypes.string.isRequired,
	lastName: PropTypes.string.isRequired
});

export const financialDataProps = PropTypes.shape({
	currentLoanInterestRateValue: PropTypes.string.isRequired,
	currentOutstandingBalance: PropTypes.string.isRequired,
	refinancingTradelineId: PropTypes.string.isRequired
});

export const lendingPropTypes = PropTypes.shape({
	isClientNameReady: PropTypes.bool.isRequired,
	loanType: PropTypes.string.isRequired,
	loanRequestId: PropTypes.string.isRequired
});

export const autoPropTypes = PropTypes.shape({
	clientVehicleInfo: PropTypes.shape({
		vehicleId: PropTypes.number.isRequired,
		make: PropTypes.string.isRequired,
		model: PropTypes.string.isRequired,
		vin: PropTypes.string.isRequired,
		licensePlate: PropTypes.string.isRequired,
		mileage: PropTypes.string.isRequired,
		condition: PropTypes.string.isRequired,
		color: PropTypes.string.isRequired,
		state: PropTypes.string.isRequired,
		year: PropTypes.number.isRequired
	}).isRequired
});

export const mortgagePropTypes = PropTypes.shape({
	clientMortgageInfo: PropTypes.shape({
		addressLine1Value: PropTypes.string.isRequired,
		addressLine2Value: PropTypes.string.isRequired,
		balanceTenureMonth: PropTypes.string.isRequired,
		cityValue: PropTypes.string.isRequired,
		dwellingType: PropTypes.string.isRequired,
		estimatedValue: PropTypes.string.isRequired,
		primaryUseValue: PropTypes.string.isRequired,
		propertyTypeValue: PropTypes.string.isRequired,
		stateValue: PropTypes.string.isRequired,
		tenureValue: PropTypes.string.isRequired,
		zipCodeValue: PropTypes.string.isRequired
	}).isRequired
});
